/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocalizedName } from './localizedName';

export interface VarDate {
  is_optional?: boolean;
  is_prefilled?: boolean;
  localized_names?: Array<LocalizedName>;
  name?: string;
  type?: VarDate.TypeEnum;
}
export namespace VarDate {
  export type TypeEnum =
    | 'template'
    | 'text'
    | 'date'
    | 'image'
    | 'roompricecalc'
    | 'signature';
  export const TypeEnum = {
    Template: 'template' as TypeEnum,
    Text: 'text' as TypeEnum,
    Date: 'date' as TypeEnum,
    Image: 'image' as TypeEnum,
    Roompricecalc: 'roompricecalc' as TypeEnum,
    Signature: 'signature' as TypeEnum,
  };
}
